document.addEventListener('DOMContentLoaded', function() {
  const btnToggle = document.getElementById('mobile-menu-toggle');
  const menuDrawer = document.querySelector('.menu-drawer');

  if (btnToggle && menuDrawer) {
    btnToggle.addEventListener('click', function() {
      menuDrawer.classList.toggle('open');
    });
  }
});
